import { render } from "./StoryPage.vue?vue&type=template&id=8a0ef2b4&scoped=true"
import script from "./StoryPage.vue?vue&type=script&lang=js"
export * from "./StoryPage.vue?vue&type=script&lang=js"

import "./StoryPage.vue?vue&type=style&index=0&id=8a0ef2b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a0ef2b4"]])

export default __exports__